import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import * as ScrollMagic from "ScrollMagic";
import "ScrollMagic/scrollmagic/minified/plugins/debug.addIndicators.min.js";
import { AboutUsService } from "../about-us/about-us.service";
import { EncryptDecryptService } from "../encrypt-decrypt.service";
import { environment } from "src/environments/environment";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CookieService } from "ngx-cookie-service";
import { OwlOptions } from "ngx-owl-carousel-o";
import { Meta, Title } from "@angular/platform-browser";
import { TreatmentsService } from "../treatments/treatments.service";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { ContactUsService } from "../Forms/contact-us.service";
import { HttpHeaders } from "@angular/common/http";
// import {VgAPI} from '@videogular/ngx-videogular/core/lib/core.module';
// import {registerElement} from "nativescript-exoplayer/platforms";

declare var $: any;

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})

//mohan
export class HomeComponent implements OnInit {
  // apiVG: VgAPI;
  my_mute = false;
  videoUrl = environment.configUrl;
  bannerDetails = [];
  videoCdnUrl = environment.googleCDNUrl;
  teamCarousel;

  teamCarouselOptions: OwlOptions = {
    items: 4,
    dots: true,
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        nav: false,
      },
      600: {
        items: 2,
        nav: false,
      },
      1000: {
        items: 4,
        nav: false,
      },
    },
  };

  testimonialCarousel = [
    {
      id: 1,
      testimonialTitle: "Great nurses very helpful",
      testimonialBy: "L.W. as seen on Google Reviews",
    },
    {
      id: 2,
      testimonialTitle: "Amazing service",
      testimonialBy: "G. R. as seen on Google Reviews",
    },
    {
      id: 3,
      testimonialTitle: "Very professional and consistent",
      testimonialBy: "L.S. as seen on Google Reviews",
    },
    {
      id: 4,
      testimonialTitle: "Absolutely brilliant",
      testimonialBy: "C.L. as seen on Google Reviews",
    },
  ];

  testimonialCarouselOptions: OwlOptions = {
    items: 1,
    dots: true,
    loop: true,
    autoplay: true,
    autoplayTimeout: 7000,
    autoplayHoverPause: true,
  };

  homeCarouselOptions = {
    items: 1,
    dots: true,
    loop: true,
    autoplay: true,
    animateIn: true,
    autoplayTimeout: 6000,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        nav: true,
      },
      600: {
        items: 1,
        nav: true,
      },
      1000: {
        items: 1,
        nav: true,
      },
    },
  };
  isPause = false;
  configUrl = environment.configUrl;
  title = "Smile Orhard Home";
  mutedValue = "false";
  RequestForm;
  submitted: boolean=false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private aboutUsService: AboutUsService,
    private encDecService: EncryptDecryptService,
    private _snackBar: MatSnackBar,
    private cookieService: CookieService,
    private metaService: Meta,
    private titleService: Title,
    private treatmentService: TreatmentsService,
    private fb: FormBuilder,
    private contactusService:ContactUsService
  ) {}

  ngOnInit() {
    const headers = new HttpHeaders();
    this.metaService.updateTag({ name: "twitter:title", content: this.title });
    this.metaService.updateTag({
      name: "twitter:image:alt",
      content: this.title,
    });
    this.metaService.updateTag({
      property: "og:image:alt",
      content: this.title,
    });
    this.metaService.updateTag({ property: "og:title", content: this.title });
    this.metaService.updateTag({ name: "title", content: this.title });

    this.GetBanners();

    const newRef = this
    setTimeout(function(){
      if (newRef.cookieService.get('isMessageDisplayed')) {
        $('#ModalWeAreOpenMessage').modal('hide')
      } else {
        $('#ModalWeAreOpenMessage').modal('show')
      }
    },30000)

    this.formInitialize();

    // const newThis = this
    // $(window).on('beforeunload', function () {
    //   newThis.cookieService.delete('isMessageDisplayed')
    // });


    $("#pauseBtn").on("click", function () {
      if (newRef.isPause === false) {
        newRef.isPause = true;
      } else {
        newRef.isPause = false;
      }
    });

    let videoControlID = <HTMLVideoElement>(
      document.getElementById("homesingleVideo")
    );

    if (this.cookieService.get("mutedValue")) {
      this.mutedValue = this.cookieService.get("mutedValue");
    } else {
      this.mutedValue = "true";
    }

    if (this.mutedValue == "false") {
      if (!videoControlID.muted) {
        videoControlID.muted = false;
      }
    } else {
      if (!videoControlID.muted) {
        videoControlID.muted = !videoControlID.muted;
      }
    }
    var duration = window.screen.height;
    var controller = new ScrollMagic.Controller();
    var scene = new ScrollMagic.Scene({
      triggerElement: "#homesingleVideo",
      duration: window.screen.height,
    })
      .addTo(controller)
      .on("enter", function (e) {
        if (videoControlID && videoControlID.play() !== undefined) {
          videoControlID
            .play()
            .then((_) => {
              videoControlID.play();
            })
            .catch((error) => {});
        }
      })
      .on("leave", function (e) {
        videoControlID.pause();
      });
  }

  GetTeamMembers() {
    this.aboutUsService.GetTeamMembers(0).subscribe(
      (res) => {
        if (res["success"]) {
          res["data"] = this.encDecService.dec(res["data"]);
          res["data"] = JSON.parse(res["data"]);
          if (res["data"] && res["data"].length > 0) {
            res["data"].forEach((element) => {
              element.ImageName = this.configUrl + element.ImageName;
            });
            this.teamCarousel = res["data"];
          }
        } else {
          this.teamCarousel = [];
        }
      },
      (err) => {
        this.teamCarousel = [];
      }
    );
  }

  viewTeamMember(StaffID) {
    this.router.navigate([
      "/About Us",
      { Type: "OurTeam", StaffID: this.encDecService.enc(StaffID.toString()) },
    ]);
  }

  onPlayerReady(event) {
    let videoControlID = <HTMLVideoElement>(
      document.getElementById("homesingleVideo")
    );
    // this.mutedValue = this.cookieService.get('mutedValue');
    if (this.cookieService.get("mutedValue") === "false") {
      videoControlID.muted = false;
    } else {
      videoControlID.muted = true;
    }
    if (videoControlID && videoControlID.play() !== undefined) {
      videoControlID
        .play()
        .then((_) => {
          // Automatic playback started!
          // Show playing UI.
          videoControlID.play();
        })
        .catch((error) => {
          // Auto-play was prevented
          // Show paused UI.
        });
    }
  }

  pauseBtn() {
    $("#pauseBtn").click();
  }

  MakeVideoCall() {
    if (this.cookieService.get("FirstName") === "Doctor") {
      this.cookieService.set("UserType", "Admin");
      this.cookieService.set("VideoCallInitiater", "A");
      this.router.navigate(["/VideoCall", { Type: "Admin", AdminName: "A" }]);
    } else {
      this.cookieService.set("UserType", "User");
      this.cookieService.set("VideoCallInitiater", "A");
      this.router.navigate(["/VideoCall", { Type: "User", AdminName: "A" }]);
    }
  }

  onMuteClick() {
    const newRef = this;
    $("video").each(function () {
      if (!newRef.my_mute) {
        if (!$(this).paused) {
          $(this).prop("muted", "true");
          newRef.cookieService.set("mutedValue", "true");
          newRef.mutedValue = "true";
          if ($(".muteButton i").hasClass("fa-volume-up")) {
            $(".muteButton i").removeClass("fa-volume-up");
            $(".muteButton i").addClass("fa-volume-off");
          }
        }
      } else {
        if ($(this).prop("muted")) {
          newRef.cookieService.set("mutedValue", "false");
          newRef.mutedValue = "false";
          $(this).prop("muted", false);
          $(this).prop("defaultMuted", false);
          if ($(".muteButton i").hasClass("fa-volume-off")) {
            $(".muteButton i").removeClass("fa-volume-off");
            $(".muteButton i").addClass("fa-volume-up");
          }
        }
      }
    });
    this.my_mute = !this.my_mute;
  }

  closeWeAreOpenModal() {
    this.cookieService.set("isMessageDisplayed", "true", 1);
    $("#ModalWeAreOpenMessage").modal("hide");
  }

  // GetBanners() {
  //   this.aboutUsService.GetBannerDetails("HomePage").subscribe(res => {
  //     if (res['success']) {
  //       this.bannerDetails = res['data']
  //     } else {
  //       this.bannerDetails = []
  //     }
  //   }, err => {
  //     this.bannerDetails = []
  //   })
  // }

  GetBanners() {
    if (!localStorage.getItem("BannerDetails")) {
      this.aboutUsService.GetBannerDetails("HomePage").subscribe(
        (res) => {
          if (res["success"]) {
            localStorage.setItem("BannerDetails", JSON.stringify(res["data"]));
            // localStorage.setItem('BannerDetails', JSON.stringify({ value: res['data'], ttl: 5000, now: new Date() }))
            this.bannerDetails = res["data"];
          } else {
            this.bannerDetails = [];
          }
        },
        (err) => {
          this.bannerDetails = [];
        }
      );
    } else {
      this.bannerDetails = JSON.parse(localStorage.getItem("BannerDetails"));
    }
  }

  BookAnAppointment(Reason) {
   // if (this.cookieService.get("isLoggedIn")) {
      this.router.navigate(["/Contact Us", { Reason: Reason }]);
    // } else {
    //   this.router.navigate(["/Log In", { IsAppointment: 1, Reason: Reason }]);
    // }
  }

  formInitialize(){
    this.RequestForm=this.fb.group({
      Name:new FormControl("",Validators.required),
      Number:new FormControl("",Validators.required),
      ConvenientTime:new FormControl("",Validators.required),
      TypeOfContact:new FormControl(false),
    })
  }

  SendRequest(){
    this.submitted=true
    if(!this.RequestForm.valid){
      return false
    }else{
      var ContactUsData =
      {
        name: this.RequestForm.value.Name,
        phone: this.RequestForm.value.Number,
        ConvenientTime: this.RequestForm.value.ConvenientTime,
        TypeOfContact: (this.RequestForm.value.TypeOfContact)?'Text':'Call'
      }

      var inputData = {
        "Data": ContactUsData
      }
      this.contactusService.ContactRequestForm(inputData).subscribe(res => {
        if (res['success']) {
          this.closeWeAreOpenModal()
          $('#loader').hide()
          $('#messageText').empty()
          $('#messageText').append(
            '<p class="text-success">Thank you for contacting us.  We will be in touch with you shortly.</p>'
          )
          $('#ModalCenter').modal('show')
          this.RequestForm.reset()
          this.submitted = false
        } else {
          $('#ModalWeAreOpenMessage').modal('hide')
          $('#loader').hide()
          $('#messageText').empty()
          if (res['msg']) {
            $('#messageText').append(
              '<p class="text-danger">' + res['msg'] + '</p>'
            )
          } else {
            $('#messageText').append(
              '<p class="text-danger">Oops! Something went wrong. Please try again.</p>'
            )
          }

          $('#ModalCenter').modal('show')
          // this.formVar.reset()
        }
      }, err => {
        $('#ModalWeAreOpenMessage').modal('hide')
        $('#loader').hide()
        $('#messageText').empty()
        $('#messageText').append(
          '<p class="text-danger">Oops! Something went wrong. Please try again.</p>'
        )
        $('#ModalCenter').modal('show')
        // this.formVar.reset()
      })
    }
  }
}
